module.exports = __webpack_public_path__ + "bg_footer.png?6ca92781e250fc57926bb7b760f4c2e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_footer.png
// module id = 54
// module chunks = 0